module.exports = __webpack_public_path__ + "media/images/icons/confirmed_suscription-a5a0aa97c08c3a4317c93b95535e4397.svg";